import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { E360SessionService } from '../services/e360-session.service';

export const isAuthenticatedGuard: CanActivateFn = () => {
  const e360SessionService: E360SessionService = inject(E360SessionService);
  const router: Router = inject(Router);

  if (e360SessionService.accessToken) return true;

  router.navigate(['error'], { state: { message: 'ALERT_PAGE.PLEASE_SIGN_IN_TO_ACCESS' } });
  return false;
};
